"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.authReducer = exports.clearCredentials = exports.clearKYCApproval = exports.setKYCApproved = exports.setFacetecDBRef = exports.setSkyCredentials = exports.setCredentials = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
// Clean initial state - no persistence logic here
var initialState = {
    user_id: "",
    name: "",
    surname: "",
    email: "",
    access_token: "",
    token_type: "",
    expires_in: 0,
    last_login: "",
    authenticated_via: "",
    cell_number: undefined,
    lets_trade_user_id: undefined,
    lets_trade_token: undefined,
    facetecDBRef: undefined,
    firebase_user_id: undefined, // Firebase localId for loan creation
};
var authSlice = (0, toolkit_1.createSlice)({
    name: "authSlice",
    initialState: initialState,
    reducers: {
        setCredentials: function (state, action) {
            var _a = action.payload, user_id = _a.user_id, name = _a.name, surname = _a.surname, email = _a.email, access_token = _a.access_token, token_type = _a.token_type, expires_in = _a.expires_in, last_login = _a.last_login, authenticated_via = _a.authenticated_via, cell_number = _a.cell_number, lets_trade_user_id = _a.lets_trade_user_id, lets_trade_token = _a.lets_trade_token, firebase_user_id = _a.firebase_user_id;
            state.user_id = user_id;
            state.name = name;
            state.surname = surname;
            state.email = email;
            state.access_token = access_token;
            state.token_type = token_type;
            state.expires_in = expires_in;
            state.last_login = last_login;
            state.authenticated_via = authenticated_via;
            state.cell_number = cell_number;
            state.lets_trade_user_id = lets_trade_user_id;
            state.lets_trade_token = lets_trade_token;
            state.firebase_user_id = firebase_user_id; // Store Firebase user ID for loan creation
            // Persist FaceTec enrollment reference if present
            state.facetecDBRef = action.payload.facetecDBRef;
        },
        setSkyCredentials: function (state, action) {
            var _a = action.payload, user = _a.user, firebase = _a.firebase, letsTradeToken = _a.letsTradeToken;
            state.user_id = user.id;
            state.name = user.name;
            state.surname = user.surname;
            state.email = user.email;
            state.access_token = firebase.idToken; // Use Firebase ID token as access token
            state.token_type = "Bearer";
            state.expires_in = parseInt(firebase.expiresIn);
            state.last_login = new Date().toISOString();
            state.authenticated_via = "Sky Lifestyle";
            state.firebase_user_id = firebase.localId; // Store Firebase localId for loan creation
            state.lets_trade_token = letsTradeToken; // Store LetsTrade token
            // If Sky user has an existing FaceTec enrollment, persist it
            state.facetecDBRef = user === null || user === void 0 ? void 0 : user.facetecDBRef;
            // Redux-persist will automatically persist this state
        },
        setFacetecDBRef: function (state, action) {
            state.facetecDBRef = action.payload;
        },
        setKYCApproved: function (state, action) {
            // Set KYC approval status
            state.SumSubApproved = action.payload;
        },
        clearKYCApproval: function (state) {
            // Clear KYC approval flag to force user through verification again
            state.SumSubApproved = false;
        },
        clearCredentials: function (state) {
            // Reset state to initial values
            // Redux-persist will automatically handle persistence
            state.user_id = "";
            state.name = "";
            state.surname = "";
            state.email = "";
            state.access_token = "";
            state.token_type = "";
            state.expires_in = 0;
            state.last_login = "";
            state.authenticated_via = "";
            state.firebase_user_id = undefined;
            state.cell_number = undefined;
            state.facetecDBRef = undefined;
            state.lets_trade_user_id = undefined;
            state.lets_trade_token = undefined;
        },
    },
});
exports.setCredentials = (_a = authSlice.actions, _a.setCredentials), exports.setSkyCredentials = _a.setSkyCredentials, exports.setFacetecDBRef = _a.setFacetecDBRef, exports.setKYCApproved = _a.setKYCApproved, exports.clearKYCApproval = _a.clearKYCApproval, exports.clearCredentials = _a.clearCredentials;
exports.authReducer = authSlice.reducer;
